<template>
    <div class="row">
        <div class="col-md-12 col-sm-8" v-if="title">
            <h3 :style="'font-size:' + font_size + 'px; text-align: ' + text_align + ';'">
                <b>Datos legales: </b>
            </h3> 
        </div>

        <div class="col-md-12 col-sm-8 mt-3">
            <div class="form-group pb-1">
                <div class="checkbox-container mb-4">
                    <input type="checkbox" name="privacidad" id="privacidad" v-model="abonado.privacidad" disabled/>
                    <label for="privacidad">
                        <span>{{ $t('formularios.he_leido') }}&nbsp;</span>

                        <router-link
                            :to="{ name: 'legal' }"
                            target="_blank"
                        >
                            <span>{{ $t('formularios.terminos_condiciones') }}</span>
                        </router-link>

                        y la

                        <router-link
                            :to="{ name: 'privacidad' }"
                            target="_blank"
                        >
                            <span>{{ $t('formularios.politica_privacidad') }}</span>
                        </router-link>
                    </label>
                </div>
            </div>

            <div class="form-group pb-1">
                <div class="checkbox-container mb-4">
                    <input type="checkbox" name="condiciones" id="condiciones" v-model="abonado.condiciones" disabled/>
                    <label for="condiciones">{{ $t('formularios.acepto') }}
                        <router-link :to="{ name: 'condiciones_generales'}" target="_blank">
                            <span>{{ $t('formularios.condiciones') }}</span>
                        </router-link>
                    </label>
                </div>
            </div>

            <div class="form-group pb-1">
                <div class="checkbox-container mb-4">
                    <input type="checkbox" name="comunicaciones" id="comunicaciones" v-model="abonado.comunicaciones"/>
                    <label for="comunicaciones">{{ $t('formularios.acepto_comunicaciones', { teatro: teatro.nombre }) }}</label>
                </div>
            </div>

            <div class="form-group pb-1" v-if="abonado.plazos && abonado.plazos.length > 0">
                <div class="checkbox-container mb-4">
                    <input type="checkbox" name="condiciones_plazos" id="condiciones_plazos" v-model="abonado.condiciones_plazos"/>
                    <label for="condiciones_plazos">{{ $t('formularios.acepto_plazos') }} {{ $t('formularios.condiciones_plazos') }} {{ $t('formularios.pago_plazos') }}</label>
                </div>
            </div>

            <Button @click="editarDatosLegales()">Guardar</Button>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['abonado', 'font_size', 'text_align', 'title'],
        methods: {
            editarDatosLegales() {
                this.$emit('editar-datos-legales');
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        }
    }
</script>